import axios from '../utils/axios';
import apiUrl from '../constants/api-urls';

const helpCenter = {
    save: (params = {}) => axios.post(apiUrl.HELP_CENTER, params)
};

export default helpCenter;
